import { Template } from '@zeus/shared';
import { TypographyComponent } from '../../../../../base/typography/Typography';
import { useNormalizedPixels } from '../../../../../hooks/useResize';
import { getScaleSize } from '../../../../../utils/utils';
import { memo, useMemo } from 'react';

interface Heading {
  template: Omit<Template, 'content'>;
  scale?: number;
}

const Heading = ({ template, scale = 1 }: Heading) => {
  const { normalizePixels } = useNormalizedPixels();

  const isTemplateHeading = useMemo(() => template?.heading?.isEnabled && template.heading.value, [template?.heading]);
  const isBrandLogo = useMemo(
    () => template?.brandLogo?.isEnabled && template?.brandLogo?.image,
    [template?.brandLogo]
  );
  const fontFamily = template?.fontFamilyName;

  if (!isTemplateHeading) return null;

  return (
    <TypographyComponent
      component={'h1'}
      sx={{
        fontWeight: 700,
        fontSize: getScaleSize(normalizePixels(90, 'height'), scale),
        color: template?.heading?.color ? template?.heading?.color : '#510B03',
        fontFamily: fontFamily,
        width: !isBrandLogo ? '100%' : '80%',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        lineHeight: 'normal',
        '-webkit-line-clamp': '1',
        '-webkit-box-orient': 'vertical',
      }}
    >
      {template?.heading?.value}
    </TypographyComponent>
  );
};

export default memo(Heading);
